/**
 * API DOC: https://apiv4.stagecb.sharkscode.com/api/doc/games#/
* */

import useUrl from './helpers/useUrl'
import { isNullOrUndefined } from '../../util/validators/baseComponentsValidators'

export default (client, { apiUrl, $language, $formFactor: formFactor  }) => {
  const root = useUrl(`${apiUrl}/games`)
  const rootSearch = useUrl(`${apiUrl}/search`)
  const $formFactor = formFactor ? formFactor : () => {}

  return {
    getSectionList() {
      const url = root('public/section/list')

      return client.get(url)
    },

    getSectionViewLayout({ term, platform }) {
      const url = root(`/public/section/item/layout-mode/${term}`)
      if (!platform) platform = $formFactor()

      const params = { platform }

      return client.get(url, { params })
    },

    getSectionViewList({ term, take, page }) {

      const params = {
        ...(!isNullOrUndefined(take) && { take }),
        ...(!isNullOrUndefined(page) && { page }),
      }

      const url = root(`/public/section/item/list-mode/${term}`)

      return client.get(url, { params })
    },

    getSubsectionItem({ term, take, page, platform, options = {} }) {
      const url = root(`/public/subsection/item/${term}`)
      if (!platform) platform = $formFactor()

      const params = {
        ...(!isNullOrUndefined(take) && { take }),
        ...(!isNullOrUndefined(page) && { page }),
        platform,
        ...options,
      }

      return client.get(url, { params })
    },

    toggleGameFavorites({ game, method }) {
      const url = root('public/toggle-favorites')
      const data = {
        game,
        method,
      }

      return client.post(url, data)
    },

    favoritesMetaList() {
      const url = root('/public/favorites-meta-list')
      return client.get(url)
    },

    getProviderItem({ term, take, page, displayMode, platform, options = {} }) {
      const url = root(`/public/provider/item/${term}`)
      if (!platform) platform = $formFactor()

      const params = {
        ...(!isNullOrUndefined(take) && { take }),
        ...(!isNullOrUndefined(page) && { page }),
        ...(!isNullOrUndefined(displayMode) && { displayMode }),
        platform,
        ...options,
      }

      return client.get(url, { params })
    },

    getCollectionItem({ term, take, page, platform, options = {} }) {
      const url = root(`/public/collection/item/${term}`)
      if (!platform) platform = $formFactor()

      const params = {
        ...(!isNullOrUndefined(take) && { take }),
        ...(!isNullOrUndefined(page) && { page }),
        platform,
        ...options,
      }

      return client.get(url, { params })
    },

    getFilters({ preset, type, mode, term }) {
      const url = root(`/public/settings/filters/${preset}`)
      const localization = $language()
      const params = {
        localization,
        type,
        mode,
        term,
      }

      return client.get(url, { params })
    },

    searchGamesProviders({ search }) {
      const url = rootSearch('public/search')
      const params = {
        search,
      }

      return client.get(url, { params })
    },
  }
}
